import { render, staticRenderFns } from "./BlackBoard.vue?vue&type=template&id=1e247674&"
import script from "./BlackBoard.vue?vue&type=script&lang=js&"
export * from "./BlackBoard.vue?vue&type=script&lang=js&"
import style0 from "./BlackBoard.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BlackBoard.vue"
export default component.exports